import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import styles from './SignUp.module.scss';
import Button from '../../common/Button';
import Input from '../../blocks/Input';
import { requiredValidator, emailValidator, passwordValidator, isFormValid } from '../../../utils/validators';
import PhoneInput from '../../blocks/PhoneInput';
import { Tabs, Tab } from 'react-bootstrap';
import history from '../../../utils/history';
import PasswordRequirements from '../PasswordRequirements';

const validators = [
  {
    key: 'phone',
    validator: [requiredValidator],
  },
  {
    key: 'first_name',
    validator: [requiredValidator],
  },
  {
    key: 'last_name',
    validator: [requiredValidator],
  },
  {
    key: 'password',
    validator: [requiredValidator, passwordValidator],
  },
  {
    key: 'email',
    validator: [requiredValidator, emailValidator],
  },
];

function SignUp(props) {
  let [form, setForm] = useState({
    phone: '',
    first_name: '',
    last_name: '',
    password: '',
    email: '',
  });

  const onSubmit = (e) => {
    e.preventDefault();

    const { first_name, last_name, password, email, phone } = form;

    const data = {
      first_name: first_name,
      last_name: last_name,
      email: email,
      password: password,
      phone: phone,
    };

    props.create(data);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm({
      ...form,
      [name]: value,
    });
  };

  function renderPasswordRequirements() {
    const missedRequirement = passwordValidator(form.password, form).missedRequirement;

    return (
      <PasswordRequirements
        isPasswordBeingSet={form.password.length}
        isMissingRequirement={{
          last4PasswordsRequirement: false,
          ...missedRequirement,
        }}
      />
    );
  }

  return (
    <>
      <Tabs
        defaultActiveKey="signup"
        className={cn(styles.tabs, 'tabs', 'tabs-full-width')}
        onSelect={(tab) => (tab === 'signin' ? history.push('/signin') : null)}
      >
        <Tab eventKey="signin" title="Sign In"></Tab>
        <Tab eventKey="signup" title="Sign Up"></Tab>
      </Tabs>

      <form className={styles.form} onSubmit={onSubmit}>
        <label>
          First Name <span className={styles.required}>*</span>
          <Input
            name="first_name"
            marginBottom
            onChange={handleChange}
            placeholder="First Name"
            value={form.first_name}
            blur
            validate={[requiredValidator]}
            autocomplete="given-name"
          />
        </label>

        <label>
          Last Name <span className={styles.required}>*</span>
          <Input
            name="last_name"
            marginBottom
            onChange={handleChange}
            placeholder="Last Name"
            value={form.last_name}
            blur
            validate={[requiredValidator]}
            autocomplete="family-name"
          />
        </label>

        <label>
          Email Address <span className={styles.required}>*</span>
          <Input
            type="email"
            marginBottom
            name="email"
            onChange={handleChange}
            placeholder="mail@mail.com"
            value={form.email}
            blur
            validate={[requiredValidator, emailValidator]}
            autocomplete="email"
          />
        </label>

        <label>
          Phone Number <span className={styles.required}>*</span>
          <PhoneInput
            name="phone"
            onChange={handleChange}
            placeholder="Phone Number"
            value={form.phone}
            blur
            validate={[requiredValidator]}
          />
        </label>

        <label>
          Password <span className={styles.required}>*</span>
          <Input
            type="password"
            name="password"
            marginBottom
            onChange={handleChange}
            placeholder="****"
            value={form.password}
            blur
            form={form}
            validate={[requiredValidator, passwordValidator]}
            autocomplete="new-password"
          />
        </label>

        {renderPasswordRequirements()}

        <div className={styles.settings}>
          <span className={styles.errorMessage}>{props.error}</span>
        </div>

        <div className={styles.submitButton}>
          <Button text="SIGN UP" type="submit" disabled={!isFormValid(form, validators)} />
        </div>
      </form>
    </>
  );
}

export default SignUp;

SignUp.propTypes = {
  create: PropTypes.func.isRequired,
  error: PropTypes.string.isRequired,
};
